<template>
  <div class="home">
    <Carousel />
    <AboutUs />
    <Services />
    <!--<OurTeam />-->
    <Testimonials />
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from "@/components/Carousel.vue";
import AboutUs from "@/components/AboutUs.vue";
import Services from "@/components/Services.vue";
import Testimonials from "@/components/Testimonials.vue";

export default {
  name: "Home",
  components: {
    Carousel,
    AboutUs,
    Services,
    Testimonials
  }
};

</script>
<!-- import OurTeam from "@/components/OurTeam.vue";,
    OurTeam-->
